// 텍스트 필드, 메뉴아이템 커스터마이징
import { styled } from "@mui/system";
import {
  Box,
  Button,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Pagination,
  Paper,
  Select,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import React, { useContext, useEffect, useState } from "react";
import DataContext from "../../../../ContextServer/DataContext";
import PwCheckPopup from "../User/Answer/PwCheckPopup";
import { RiAdminLine } from "react-icons/ri";
import { FaFilter, FaSort } from "react-icons/fa";
import { Table } from "react-bootstrap";
import TableListPopUp from "./TableListPopUp";
import { LoginContext } from "../../../../ContextServer/LoginConetxt";
import { useNavigate } from "react-router-dom";

const CustomFormControl = styled(FormControl)`
  && {
    & .MuiInputBase-root {
      border: 1px solid #ddd;
      color: #f4f5f5;
      background-color: #ddd;
      text-align: left;
      height: 47.78px;
    }

    & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: #f4f5f5;
    }

    & .MuiSelect-icon {
      color: #f4f5f5;
    }
  }
`;
const CustomOutlinedInput = styled(OutlinedInput)`
  && {
    background-color: #fac426 !important;
    color: #f4f5f5;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    &:hover {
      background-color: #fa8526 !important;
    }

    & .MuiListItemIcon-root {
      min-width: 32px;
    }
  }
`;

const CustomChipBox = styled(Box)`
  && {
    display: flex;
    flex-wrap: wrap;
  }
`;

const CustomMenuItem = styled(MenuItem)`
  && {
    font-weight: ${({ selected, theme }) =>
      selected
        ? theme.typography.fontWeightMedium
        : theme.typography.fontWeightRegular};
  }
`;
const theme = createTheme();

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#fa8526",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function AdminDeclareList() {
  const {
    odorReports,
    stdate,
    eddate,
    setStdate,
    setEddate,
    adminChange,
    setAdminChange,

    GetEditId,

    replyId,
    setReplyId,
    adminLogin,
    setAdminLogin,
  } = useContext(DataContext);
  const { suc, setSuc } = useContext(LoginContext);

  // 최신순
  // console.log(odorReports)
  const [sortColumn, setSortColumn] = useState(null); // 정렬 기준 열
  const [sortDirection, setSortDirection] = useState(null); // 정렬 방향

  // 1. 악취 강도 선택할 수 있는 토글 (톱니바퀴)
  // 악취 강도 선택 상자의 표시 여부 관리
  const [showIntensitySelect, setShowIntensitySelect] = useState(false);
  // 사용자가 선택한 악취 강도를 저장
  const [selectedIntensity, setSelectedIntensity] = useState(["전체"]);

  const [filteredData, setFilteredData] = useState([...odorReports]); // 상태 변수로 변경

  const handleIntensityChange = (event) => {
    const { value } = event.target;

    if (value.includes("전체")) {
      setSelectedIntensity(intensityOptions.map((option) => option.value));
    } else {
      setSelectedIntensity(value);
    }
  };

  // 악취 강도 선택 상자를 토글
  const handleToggleIntensitySelect = () => {
    setShowIntensitySelect(!showIntensitySelect);
  };

  const intensityOptions = [
    { label: "전체", value: "전체" },
    { label: "(0) 무취", value: "무취" },
    { label: "(1) 감지취기", value: "약간느낌" },
    { label: "(2) 보통취기", value: "보통냄새" },
    { label: "(3) 강한취기", value: "강한냄새" },
    { label: "(4) 극심한취기", value: "극심한냄새" },
    { label: "(5) 참기어려운취기", value: "참기어려운냄새" },
  ];

  const equivalentValues = {
    전체: [
      "전체",
      "무취",
      "약간느낌",
      "보통냄새",
      "강한냄새",
      "극심한냄새",
      "참기어려운냄새",
    ],
    "무취 - 평상시 후각으로 아무것도 감지하지 못하는 정도": "무취",
    "약간느낌 - 무슨 냄새인지 알 수 없으나 약간의 냄새를 느낄 수 있는 정도":
      "약간느낌",
    "보통냄새 - 무슨 냄새인지 알 수 있는 정도": "보통냄새",
    "강한냄새 - 쉽게 감지할 수 있는 정도의 강한 냄새, 병원의 크레졸 냄새 수준":
      "강한냄새",
    "극심한냄새 - 아주 강한 냄새, 여름철 재래식 화장실냄새 수준": "극심한취기",
    "참기어려운냄새 - 견디기 어려운 강렬한 냄새로써 호흡이 정지될 것 같은 수준":
      "극심한냄새",
  };

  // 3. 항목별 필터링

  const applyFilters = () => {
    let newData = [...odorReports]; // newData 변수 초기화

    // 필터링 로직
    if (selectedIntensity.includes("전체")) {
      // 전체 강도 선택 시 모든 데이터 유지
      newData = [...odorReports];
    } else {
      newData = newData.filter((report) => {
        const intensity =
          equivalentValues[report.stink_levelnm] || report.stink_levelnm;
        return selectedIntensity.includes(intensity); // 선택한 강도에 해당하는 데이터 필터링
      });
    }

    /*  (2) 날짜 범위에 따른 필터링
            stdate와 eddate가 모두 존재하는 경우,
            filteredData를 해당 날짜 범위 내의 신고만으로 필터링
        */
    if (stdate && eddate) {
      newData = newData.filter((report) => {
        return (
          report.datetime >= stdate + " 00:00:00" &&
          report.datetime <= eddate + " 23:59:59"
        );
      });
    }

    /* (3) 정렬 기준에 따른 정렬, 정렬 로직 추가
           sortColumn과 sortDirection 값이 모두 존재하는 경우,
           filteredData를 해당 기준으로 정렬.
           오름차순(asc) 또는 내림차순(desc) 방향으로 정렬.
        */
    if (selectedIntensity.length > 0 && !selectedIntensity.includes("전체")) {
      newData = newData.filter((report) => {
        const intensity =
          equivalentValues[report.stink_levelnm] || report.stink_levelnm;
        return selectedIntensity.includes(intensity);
      });
    }

    if (sortColumn && sortDirection) {
      newData = newData.sort((a, b) => {
        if (a[sortColumn] < b[sortColumn])
          return sortDirection === "asc" ? -1 : 1;
        if (a[sortColumn] > b[sortColumn])
          return sortDirection === "asc" ? 1 : -1;
        return 0;
      });
    }
    // 필터링 및 정렬된 목록을 설정
    setFilteredData(newData);
  };

  // 4. 최신순 기능
  const handleSortColumn = (column) => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortColumn(column);
      setSortDirection("asc");
    }
  };

  useEffect(() => {
    applyFilters();
  }, [
    selectedIntensity,
    stdate,
    eddate,
    sortColumn,
    sortDirection,
    odorReports,
  ]);

  // 5. 페이지네이션
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  //관리자 모드 답변 오픈모달
  //비밀번호 체크모달
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const navigate = useNavigate();

  return (
    <div>
      <ThemeProvider theme={theme}>
        <TableListPopUp open={open} handleClose={handleClose} />

        <div
          className="declarelist-container"
          style={{ backgroundColor: "#fff5ed" }}
        >
          <div className="declarelist-box">
            <div className="declarelist-contents">
              <Button
                variant="outlined"
                sx={{ float: "right" }}
                color={"info"}
                onClick={() => {
                  navigate("/odor/declarelist/");
                }}
              >
                사용자 모드 전환
                <RiAdminLine />
              </Button>

              <div className="declareTitle">
                <h2>
                  악취 신고 목록 <small>(관리자)</small>{" "}
                </h2>
              </div>

              <div className="date-select">
                <div className="date-bundle">
                  <input
                    type="date"
                    value={stdate}
                    onChange={(e) => setStdate(e.target.value)}
                  />
                  <span>to</span>
                  <input
                    type="date"
                    value={eddate}
                    onChange={(e) => setEddate(e.target.value)}
                  />
                </div>
                <div className="moreView" onClick={handleToggleIntensitySelect}>
                  <FaFilter
                    className={`settings-icon ${
                      showIntensitySelect ? "active" : ""
                    }`}
                  />
                  <p>강도별</p>
                </div>
              </div>

              {/* 악취 강도 선택 box */}

              {showIntensitySelect && (
                <CustomFormControl>
                  <InputLabel htmlFor="multiple-chip-label">
                    악취 강도별 신고 결과 보기
                  </InputLabel>
                  <Select
                    labelId="multiple-chip-label"
                    id="multiple-chip"
                    multiple
                    value={selectedIntensity}
                    onChange={handleIntensityChange}
                    input={
                      <CustomOutlinedInput
                        id="select-multiple-chip"
                        label="Chip"
                      />
                    }
                    renderValue={(selected) => {
                      if (selected.includes("전체")) {
                        // 선택된 값에 "전체"가 포함되어 있다면, "전체"를 제외한 나머지 값만 표시합니다.
                        const selectedValues = selected.filter(
                          (value) => value !== "전체"
                        );
                        return (
                          <CustomChipBox>
                            {selectedValues.map((value) => (
                              <Chip key={value} label={value} />
                            ))}
                          </CustomChipBox>
                        );
                      } else {
                        // "전체"가 선택되지 않은 경우에는 모든 선택된 값을 표시합니다.
                        return (
                          <CustomChipBox>
                            {selected.map((value) => (
                              <Chip key={value} label={value} />
                            ))}
                          </CustomChipBox>
                        );
                      }
                    }}
                  >
                    {intensityOptions.map((option) => (
                      <CustomMenuItem
                        key={option.value}
                        value={option.value}
                        // selected={selectedIntensity.indexOf(option.value) !== -1}
                        selected={selectedIntensity.includes(option.value)}
                        theme={theme}
                      >
                        {option.label}
                      </CustomMenuItem>
                    ))}
                  </Select>
                </CustomFormControl>
              )}

              <ThemeProvider theme={theme}>
                <TableContainer className="tableContainer" component={Paper}>
                  <Table className="list-table">
                    <TableHead>
                      <TableRow>
                        <StyledTableCell>
                          발생일
                          <FaSort
                            className={`sort-icon ${
                              sortColumn === "datetime" ? "active" : ""
                            }`}
                            onClick={() => handleSortColumn("datetime")}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          지역
                          <FaSort
                            className={`sort-icon ${
                              sortColumn === "report_addr" ? "active" : ""
                            }`}
                            onClick={() => handleSortColumn("report_addr")}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          악취 강도
                          <FaSort
                            className={`sort-icon ${
                              sortColumn === "stink_levelnm" ? "active" : ""
                            }`}
                            onClick={() => handleSortColumn("stink_levelnm")}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          악취 종류
                          <FaSort
                            className={`sort-icon ${
                              sortColumn === "stink_div" ? "active" : ""
                            }`}
                            onClick={() => handleSortColumn("stink_div")}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          작성자
                          <FaSort
                            className={`sort-icon ${
                              sortColumn === "stink_div" ? "active" : ""
                            }`}
                            onClick={() => handleSortColumn("stink_div")}
                          />
                        </StyledTableCell>

                        <StyledTableCell>
                          답변확인
                          <FaSort
                            className={`sort-icon ${
                              sortColumn === "stink_div" ? "active" : ""
                            }`}
                            onClick={() => handleSortColumn("stink_div")}
                          />
                        </StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredData?.length !== 0 ? (
                        filteredData?.map((item) => (
                          <>
                            <StyledTableRow
                              key={item.id}
                              onClick={() => {
                                handleOpen();
                                GetEditId(item.seqno);
                                setReplyId(item.seqno);
                              }}
                            >
                              <StyledTableCell>
                                {window.innerWidth < 600
                                  ? item.datetime.substring(5, 16)
                                  : item.datetime}
                              </StyledTableCell>
                              <StyledTableCell>
                                {window.innerWidth < 600
                                  ? item.report_addr.substring(0, 5) + "..."
                                  : item.report_addr}
                              </StyledTableCell>
                              <StyledTableCell>
                                {window.innerWidth < 600
                                  ? item.stink_levelnm.substring(0, 5) + "..."
                                  : item.stink_levelnm}
                              </StyledTableCell>
                              <StyledTableCell>
                                {item.stink_div}
                              </StyledTableCell>
                              <StyledTableCell>
                                {item.report_nm}
                              </StyledTableCell>
                              <StyledTableCell>
                                {item.proccess === "0" ? (
                                  <Button color={"warning"}>미답변</Button>
                                ) : (
                                  <Button>답변완료</Button>
                                )}
                              </StyledTableCell>
                            </StyledTableRow>
                          </>
                        ))
                      ) : (
                        <StyledTableRow>
                          <StyledTableCell colSpan={4}>
                            기간 내에 등록된 신고목록이 없습니다.
                          </StyledTableCell>
                        </StyledTableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </ThemeProvider>

              {/* 페이지네이션 */}
              <TablePagination
                sx={{ minWidth: "100%" }}
                variant="outlined"
                rowsPerPageOptions={[15, 14, 21, 100]}
                component="div"
                count={filteredData.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                style={{ width: "100%", backgroundColor: "orange" }}
                size={"small"}
              />
            </div>
          </div>
        </div>
      </ThemeProvider>
    </div>
  );
}

export default AdminDeclareList;
